<!--
Copyright (C) Cocouz Oy 2017 - All Rights Reserved
-->
<template>
  <div class="be-horizontal col-lg-12 col-xl-12" :class="{'isNCH': isNCH}">

            <div class="aside position-none" id="aside" v-bind:style="stickyObject" :class="{'stop-float': footerCollided}">
            <MPCollider v-collision="['groupone']" @collide="onCollideHandler" @non-collide="nonCollideHandler" @collide-groupone="onGroupOneCollide" @non-collide-groupone="nonGroupOneCollide" />
              
              <!-- Form -->
              <ul v-show="!isNCH" class="tabs tabs--aside tab-title">
                <li class="tabs__item" :class="{'current' : packageCurrent}" data-tab="tab-1" @click="changeCurrentTab('package')" v-if="!isPackageTabRemoved">{{ strings.packagetab}}</li>
                <li class="tabs__item" :class="{'current' : roomCurrent}" data-tab="tab-2" @click="changeCurrentTab('room')" v-if="!isPackageTabRemoved">{{ strings.roomtab }}</li>
              <!--  <li class="tabs__item current" v-if="showEnquiry">Enquiry</li> -->
              </ul>
              <div class="form aside__basics horizontal-form">
                  <label v-if="!isNCH" class="form__label input-width--20" :class="{'input-width--42' : isMoreThanOneDay, 'input-width--27' : (isOpera && currentTab == 'package' && !isMoreThanOneDay) }"> <span style="height:22px;display:block;"> {{ strings.meetingLength }} </span>
                    <select name="length" class="form__input form__select" :class="{'ie': isIE }" v-model="s_meetingLength">
                      <option value="1" v-if="isRadisson && currentTab == 'room'">1 h</option>
                      <option value="2" v-if="!isOpera || (isOpera && currentTab == 'room')">2 {{strings.hourSymbol}}</option>
                      <option value="3" v-if="!isOpera || (isOpera && currentTab == 'room')">3 {{strings.hourSymbol}}</option>
                      <option value="4" v-if="!isOpera || (isOpera && currentTab == 'room')">4 {{strings.hourSymbol}}</option>
                      <option value="5" v-if="!isOpera || (isOpera && currentTab == 'room')">5 {{strings.hourSymbol}}</option>
                      <option value="6" v-if="!isOpera || (isOpera && currentTab == 'room')">6 {{strings.hourSymbol}}</option>
                      <option value="7" v-if="!isOpera || (isOpera && currentTab == 'room')">7 {{strings.hourSymbol}}</option>
                      <option value="8" v-if="!isOpera || (isOpera && currentTab == 'room')">8 {{strings.hourSymbol}}</option>
                      <option value="9" v-if="!isOpera || (isOpera && currentTab == 'room')">9 {{strings.hourSymbol}}</option>
                      <option value="10" v-if="!isOpera || (isOpera && currentTab == 'room' && !isRadisson)">10 {{strings.hourSymbol}}</option>
                      <option value="overnight" v-if="!isOpera && !isNCH">{{ strings.overnight }}</option>
                      <option value="twodays" v-if="!isOpera && !isNCH">{{ strings.twodays }}</option>
                      <option value="oneday" v-if="isOpera && currentTab == 'package'">{{ strings.oneday }}</option>
                      <option value="overone" v-if="isOpera && !isRadisson && false">{{ strings.morethanoneday }}</option>
                    </select>
                  </label>
                  <label class="form__label input-width--20" v-show="!isMoreThanOneDay" :class="{'input-width--42' : isMoreThanOneDay, 'input-width--27' : (isOpera && currentTab == 'package' && !isMoreThanOneDay) }">
                   <span style="height:22px;display:block;"> {{ strings.startd }} </span>
                    <input v-model="s_date" class="flatpickr form__input js-datepicker flatpickr-input" id="fpick" ref="fpick" :placeholder="strings.whenyourmeetingis">
                  </label>
                  <label class="form__label input-width--20" style="display:none;">
                    <span style="height:22px;display:block;"> {{ strings.startd }} </span>
                    <input disabled class="form__input" placeholder="Disabled">
                  </label>

                  <!--<label class="form__label input-width--20" v-show="isMoreThanOneDay">
                    {{ strings.endd }}
                    <input v-model="s_end_date" class="flatpickr form__input js-datepicker flatpickr-input" id="fpick_end" ref="fpick_end" placeholder="">
                  </label>-->

                  <!--<label class="form__label  input-width--20" v-show="!isMoreThanOneDay">
                    {{ strings.starttime }}
                    <vue-timepicker v-model="s_time" class="vueTimePicker" :minute-interval="15" hide-clear-button ></vue-timepicker>
                  </label>-->
                  <div class="form__label  input-width--20" 
                      v-show="(!isOpera && !isNCH) || ( (isOpera || isNCH) && currentTab == 'room' && !isMoreThanOneDay)" 
                      :class="{'input-width--42' : isMoreThanOneDay, 'input-width--27' : (isOpera && currentTab == 'package' && !isMoreThanOneDay) }">
                    <span style="display:block;height:22px;"> {{ strings.starttime }} </span>
                    <vue-timepicker input-width="100%" :hour-label="strings.hourLabel" :minute-label="strings.minuteLabel" :hour-range="getTimePickerHourRange" v-model="s_time" class="vueTimePicker" :minute-interval="15" hide-clear-button ></vue-timepicker>
                  </div>

                  <label style="display:none;" class="form__label input-width--20">
                    {{ strings.starttime }}
                    <input disabled class="form__input" placeholder="Disabled">
                  </label>

                  <label v-if="isNCH" class="form__label input-width--20" :class="{'input-width--42' : isMoreThanOneDay, 'input-width--27' : (isOpera && currentTab == 'package' && !isMoreThanOneDay) }"><span style="display:block;height:22px;"> &nbsp{{ strings.meetingLength }} </span>
                    <select name="length" class="form__input form__select" :class="{'ie': isIE }" v-model="s_meetingLength">
                      <option value="2" v-if="!isOpera || (isOpera && currentTab == 'room')">2 h</option>
                      <option value="3" v-if="!isOpera || (isOpera && currentTab == 'room')">3 h</option>
                      <option value="4" v-if="!isOpera || (isOpera && currentTab == 'room')">4 h</option>
                      <option value="5" v-if="!isOpera || (isOpera && currentTab == 'room')">5 h</option>
                      <option value="6" v-if="!isOpera || (isOpera && currentTab == 'room')">6 h</option>
                      <option value="7" v-if="!isOpera || (isOpera && currentTab == 'room')">7 h</option>
                      <option value="8" v-if="!isOpera || (isOpera && currentTab == 'room')">8 h</option>
                      <option value="9" v-if="!isOpera || (isOpera && currentTab == 'room')">9 h</option>
                      <option value="10" v-if="!isOpera || (isOpera && currentTab == 'room')">10 h</option>
                      <option value="overnight" v-if="!isOpera && !isNCH"> {{ strings.overnight }}</option>
                      <option value="twodays" v-if="!isOpera && !isNCH">{{ strings.twodays }}</option>
                      <option value="oneday" v-if="isOpera && currentTab == 'package'">{{ strings.oneday }}</option>
                      <option value="overone" v-if="isOpera">{{ strings.morethanoneday }}</option>
                    </select>
                  </label>

                  <label class="form__label input-width--10" v-show="!isMoreThanOneDay"> <span style="height:22px;display:block;"> {{ strings.attendees }} </span>
                    <input type="number" class="form__input" :placeholder="strings.howmany" v-model.lazy="s_delegates" v-debounce="300" >
                  </label>
                  <label class="form__label input-width--20" 
                    :class="{'input-width--42' : isMoreThanOneDay, 'input-width--27' : (isOpera && currentTab == 'package' && !isMoreThanOneDay) }"> <span style="height:22px;display:block;"> {{ strings.seatingorder }} </span>
                    <select name="length" class="form__input form__select" v-model="s_layout">
                      <option v-for="so in seatingOrderList" :value="so.value" :key="so.id">{{  translateLayout(so.value)}}</option>
                    </select>
                  </label>
                  <label class="form__label input-width--12" v-show="isMoreThanOneDay">
                    <button type="submit" href="" class="button button--success button--full tabs__button" @click.prevent="gotoCheckout()"
                    :disabled="isButtonDisabled" :class="{'button--disabled':isButtonDisabled}"
                    > <span style="height:22px;display:block;"> {{ strings.continue }} </span> </button>
                  </label>

               <!-- <p class="form__note form__note--subtle" v-show="minimumCharge > 1 && currentTab == 'package' && !isDisabled">{{ strings.minimumcharge }} <strong>{{ minimumCharge }} {{strings.attendees_lc }}</strong>, {{ strings.butyoucan }}.</p>
              -->
              <div class="error_block">
                <p class="form__note" v-if="isOutsideBusinessHours && businessHours['start_time']" style="text-align: center; font-size:14px;">{{ strings.bizHours }}: {{ businessHours['start_time'] }} - {{ businessHours['end_time'] }}</p>
                <p class="form__note" v-if="isOutsideBusinessHours && businessHours['venue_closed']" style="text-align: center; font-size:14px;">{{ strings.venueClosed }}</p>
                <p class="form__note" v-if="isClosed" style="text-align: center; font-size:14px;">{{ strings.venueClosed }}</p>
                <p class="form__note" v-if="isNCHEnquiry && !isOutsideBusinessHours" style="max-width: 600px; font-size:14px;">{{ strings.nchEnquiryMessage }}</p>
              </div>
              <MPDiscountCodeBlock />
              </div>

            </div>
          </div>
</template>

<script>
  //import flatPickr from 'vue-flatpickr-component';
  import fpickr from "flatpickr"
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  //import locale for flatpickr.
  import { Russian } from "flatpickr/dist/l10n/ru.js";
  import { Finnish } from "flatpickr/dist/l10n/fi.js"
  import { Danish } from "flatpickr/dist/l10n/da.js"
  import { French } from "flatpickr/dist/l10n/fr.js"
  import { German } from "flatpickr/dist/l10n/de.js"
  import { Italian } from "flatpickr/dist/l10n/it.js"
  import { Latvian } from "flatpickr/dist/l10n/lv.js"
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import { Swedish } from "flatpickr/dist/l10n/sv.js"
  import { Mandarin } from "flatpickr/dist/l10n/zh.js"
  import { Czech } from "flatpickr/dist/l10n/cs.js"
  import { english } from "flatpickr/dist/l10n/default.js"

  // import locacle for vee-validate.
  import arabic from 'vee-validate/dist/locale/ar';
  import russian from "vee-validate/dist/locale/ru";
  import finnish from "vee-validate/dist/locale/fi"
  import danish from "vee-validate/dist/locale/da"
  import french from "vee-validate/dist/locale/fr"
  import german from "vee-validate/dist/locale/de"
  import italian from "vee-validate/dist/locale/it"
  //import latvian from "vee-validate/dist/locale/lv"
  import spanish from "vee-validate/dist/locale/es"
  import swedish from "vee-validate/dist/locale/sv"
  import chinese from "vee-validate/dist/locale/zh_CN"

  import MPCollider from './Collider';
  import Vue from 'vue'
  import VueResource from 'vue-resource';
  import moment from 'moment';
  import MPDiscountCodeBlock from './DiscountCodeBlock'

  import VuePhoneInput from './VuePhoneInput'
  const { detect } = require('detect-browser');
  const browser = detect();
  import * as hf from '../assets/misc/helperFunctions.js'
  import * as dataLayer from '../assets/misc/dataLayer.js';

  import VueTimepicker from 'vue2-timepicker'

  Vue.use(VueResource);

  export default {
    props: ['lang'],
    components: {
      MPCollider,
      PulseLoader,
      VuePhoneInput,
      VueTimepicker,
      MPDiscountCodeBlock
    },
    data () {
      return {
        date: null,
        stickyObject:  {},
        vInfo : '',
        s_email: '',
        s_phone: '',
        s_name: '',
        pInfo: '',
        roomPrice: '',
        roomTotalPrice: '',
        s_lname: '',
        s_company: '',
        s_additional_info: '',
        isIE: false,
        details: true,
        detailsPackage: true,
        detailsRoomText: this.$store.state.strings.details,
        detailsPackageText: this.$store.state.strings.details,
        noCC: false,
        s_phone_logged_in: '',
        s_timee: '10:15',
        _accepted_gdpr: false      }
    },
    created () {
      this.$validator.localize('ar', arabic);
      this.$validator.localize('ru', russian);
      this.$validator.localize('fi', finnish);
      this.$validator.localize('da', danish);
      this.$validator.localize('fr', french);
      this.$validator.localize('de', german);
      this.$validator.localize('it', italian);
      this.$validator.localize('es', spanish);
      this.$validator.localize('sv', swedish);
      //this.$validator.localize('lv', latvian);
      this.$validator.localize('zh', chinese);

      // start with english locale.
      this.$validator.localize('en');
    },
    methods: {
      goToCheckout(){
          if(this.useNewCheckoutPage){
              this.$store.dispatch('goToCheckout', {});
          } else {
              this.$store.dispatch('goToOperaCheckout', {});
          }
      },
      translateLayout(layoutCode) {
        return this.strings?.layouts[layoutCode];       
      },
      reRender(lang) {
        this.$validator.localize(lang);
        switch (lang) {
          case 'ru':
            fpickr.localize(Russian);
            break;
          case 'fi':
            fpickr.localize(Finnish);
            break;
          case 'da':
            fpickr.localize(Danish);
            break;
          case 'fr':
            fpickr.localize(French);
            break;
          case 'de':
            fpickr.localize(German);
            break;
          case 'it':
            fpickr.localize(Italian);
            break;
          case 'lv':
            fpickr.localize(Latvian);
            break;
          case 'es':
            fpickr.localize(Spanish);
            break;
          case 'sv':
            fpickr.localize(Swedish);
            break;
          case 'zh':
            fpickr.localize(Mandarin);
            break;
          case 'cs':
            fpickr.localize(Czech);
            break;
          case 'en':
            fpickr.localize(english);
            break;
          default:
            break;
        }
        let isOpera = this.$store.state.isOpera;
        let date = moment(this.$store.state.date, 'DD-MM-YYYY');

        let defaultDate = moment();
        if(parseInt(this.$store.state.venueInfo.id) == 94150){
          defaultDate = defaultDate.startOf('hour').add(2, 'hours');
        } else {
          defaultDate = moment();
        }

        let finalDate = '';
        if(date > defaultDate){
          finalDate = date;
        } else {
          this.$store.commit('setDate', defaultDate.format('DD-MM-YYYY'));
          finalDate = defaultDate;
        }

        let time = moment(this.$store.state.time, 'HH:mm');

        /*fpickr("#fpick", {
          altInput: true,
          dateFormat: 'd-m-Y',
          defaultDate: finalDate.format('DD-MM-YYYY'),
          minDate: defaultDate.format('DD-MM-YYYY'),

        });
*/
        fpickr("#fpick_end", {
          altInput: true,
          dateFormat: 'd-m-Y',
          defaultDate: finalDate.add(1, 'days').format('DD-MM-YYYY'),
          minDate: finalDate.add(1, 'days').format('DD-MM-YYYY'),

        });

        fpickr("#fpick_time", {
          dateFormat: 'H:i',
          enableTime: true,
          defaultHour: time.format('HH'),
          defaultMinute: time.format('mm'),
          minuteIncrement: 30,
          time_24hr: true,
          noCalendar: true
        });
      },
      changeCurrentTab(value) {
        this.$store.commit('setCurrentTab', value);

        if(this.isMoreThanOneDay){
          this.$store.commit('resetEventLists');
        }
        if(value == 'package'){
          if(this.$store.state.isOpera){
            if(!this.isMoreThanOneDay){
              this.$store.commit('setMeetingLength', 'oneday');
            }
            // Change back to getOperaPackage after demo
            this.$store.dispatch('getOperaPackage', this.$store.state.venueInfo.id);
          } else {
            this.$store.dispatch('getPackage', this.$store.state.venueInfo.id);
          }         
        } else {
          //this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
          if(this.$store.state.isOpera){
            if(!this.isMoreThanOneDay){
              let mt_length = 8
              if(window.default_meeting_length){
                mt_length = window.default_meeting_length
              }
              this.$store.commit('setMeetingLength', mt_length);
            }
            this.$store.dispatch('getRoomOpera', {
                'id' : this.$store.state.venueInfo.id,
                'hotelID' : this.$store.state.venueInfo.operaHotelID,
                'hotelChainCode' : this.$store.state.venueInfo.operaChainCode,
                'hotelServer' : this.$store.state.venueInfo.operaServer
              });
          } else {
            this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
          }
        }
        this.$store.dispatch('checkLeadTimes');
      },
      isRightPackage(packageLength){
        let mt_length = parseInt(this.$store.state.meeting_length);
        let isOpera = this.$store.state.isOpera;
        let pk = '';
        if(mt_length >= 2 && mt_length <= 5){
            pk = '4'
        } else if(mt_length >= 6 && mt_length <= 10 ) {
            pk = '8'
        } else if(this.$store.state.meeting_length == 'overnight'){
            pk = '24'
        } else if(this.$store.state.meeting_length == 'twodays'){
            pk = '36'
        }

        if(packageLength == pk || isOpera){
            return true;
        } else {
            return false;
        }
      },
      toggleDetails() {
        this.$store.commit('toggleDetailId', this.s_room);
        if(document.documentElement.clientWidth > 1023){
          this.$scrollTo('.room_' + this.s_room);
        }
        if(this.details == true) {
          this.detailsRoomText = this.$store.state.strings.details;
          this.details = false;
        } else {
          this.detailsRoomText = this.$store.state.strings.hidedetails;
          this.details = true;
        }
      },
      togglePackageDetails() {
        this.$store.commit('togglePackageDetailId', this.s_package);
        if(document.documentElement.clientWidth > 1023){
          this.$scrollTo('#showingRoomPackage');
        }
        // For package dropdown
        if(this.detailsPackage == true) {
          this.detailsPackageText = this.$store.state.strings.details;
          this.detailsPackage = false;
        } else {
          this.detailsPackageText = this.$store.state.strings.hidedetails;
          this.detailsPackage = true;
        }
      },
      onCollideHandler (collider) {
      },
      nonCollideHandler (collider) {
        /*this.stickyObject =  {
          position: 'fixed',
          width: '336.66px',
          top: '121px',
          transition: 'all .3 ease-in'
        }*/
      },
      onGroupOneCollide (collider) {
        /*this.stickyObject =  {
          position: 'initial',
          width: '336.66px',
          top: '0',
          transition: 'all .3 ease-in'
        }*/
      },
      nonGroupOneCollide (collider) {
      },
      async createBooking() {
        let isOpera = this.$store.state.isOpera;
        let startD = this.$store.state.datetime;
        let operaStartD = moment(startD, 'DD-MM-YYYY HH:mm');
        operaStartD = operaStartD.format('YYYY-MM-DDTHH:mm:ss');
        let endD = moment(startD, 'DD-MM-YYYY HH:mm');
        let mt_length = '';
        let currentTab = this.$store.state.currentTab;
        let isEnquiry = this.$store.state.showEnquiryForm;
        let baseUrl = this.$store.state.baseUrl;
        let impression = {
          position: this.$store.state.selectedPosition,
          list: 'Venue',
          brand: this.$store.state.venueInfo.title + " - " + this.$store.state.venueInfo.id
        };    

        if(this.$store.state.meeting_length == 'overnight'){
          mt_length = 24;
        } else if(this.$store.state.meeting_length == 'twodays'){
          mt_length = 36;
        } else {
          mt_length = parseInt(this.$store.state.meeting_length);
        }

        endD = endD.add(mt_length, 'hours');
        let operaEndD = endD;
        endD = endD.format('DD-MM-YYYY HH:mm');
        operaEndD = operaEndD.format('YYYY-MM-DDTHH:mm:ss');

        // Check if this is Opera Venue.
        if(isOpera){
          this.$store.commit('setProcessing', 'yes');

          let roomIF = [];
          let packageIF = [];
          let layout = '';
          if(currentTab == 'room'){
            let roomList = this.$store.state.roomInfo;
            roomList.forEach(element => {
              if(element.id == this.$store.state.selectedRoom){
                roomIF['name'] = element.title;
                roomIF['photo'] = element.room_pictures[0];
                roomIF['code'] = element.code;
                roomIF['rate_code'] = element.rate_code;
              }
            });
            layout = hf.getLayoutName(this.$store.state.selectedLayout);
            packageIF['name'] = '';
            packageIF['code'] = '';
            packageIF['package_rate_code'] = '';
          } else {
            this.$store.commit('setPackageMin', this.minimumCharge);
            let roomList = this.$store.state.rooms_in_package;
            roomList.forEach(element => {
              if(element.id == this.$store.state.selectedRoominPackage){
                roomIF['name'] = element.title;
                roomIF['photo'] = element.room_pictures[0];
                roomIF['code'] = element.code;
                roomIF['rate_code'] = '';
              }
              layout = hf.getLayoutName(this.$store.state.selectedLayoutinPackage);
            });

            let packageList = this.$store.state.packageInfo;
            packageList.forEach(element => {
              if(element.id == this.$store.state.selectedPackage){
                packageIF['name'] = element.title;
                packageIF['code'] = element.id;
                packageIF['package_rate_code'] = element.package_rate_code;
              }
            });
          }
          

          this.$store.commit('setCheckOutItems', {
            'startD' : startD,
            'endD' : endD,
            'operaStartD' : operaStartD,
            'operaEndD' : operaEndD,
            'currency': this.$store.state.venueInfo.currency_code,
            'currencySymbol' : this.$store.state.venueInfo.currency,
            'room' : roomIF['name'],
            'room_code' : roomIF['code'],
            'delegates' : this.$store.state.delegates,
            'layout' : layout,
            'venue' : this.$store.state.venueInfo.title,
            'room_rate_code' : roomIF['rate_code'],
            'roomPhoto' : roomIF['photo'],
            'roomPrice' : this.$store.state.roomPrice,
            'roomTotalPrice' : this.$store.state.roomTotalPrice,
            'package' : packageIF['name'],
            'package_code' : packageIF['code'],
            'package_rate_code' : packageIF['package_rate_code'],
            'isInstantBookable': this.isInstantBookable
          });

          // Get Opera Menu Items.
          this.$store.dispatch('getOperaMenuItems').then((data) => {
            // #loghere
            let operaMenuItemsList = data.body.MeetingFetchMenuItemResponse.MenuItems;
            // Purify list
            let newList = [];
            operaMenuItemsList.forEach(element => {
              let elementPrice = 0;
              if(element.Charges.RevenueTypes.BaseRate.Amount){
                elementPrice = parseFloat(element.Charges.RevenueTypes.BaseRate.Amount);
              } else {
                elementPrice = parseFloat(element.Charges.RevenueTypes.BaseRate[0].Amount);
              }
              let newItem = {
                'id' : element.MenuItemID,
                'name' : element['@attributes'].name1,
                'price' : elementPrice,
                'priceWithCC' : elementPrice + ' ' + this.$store.state.venueInfo.currency,
                'service_time' : '--:--'
              };
              if(elementPrice > 0){
                newList.push(newItem);
              }         
            });

            this.$store.commit('setOperaMenuItems', newList);
            // End Purify list
            this.$store.commit('setAddonAjaxCounter');

            if(this.$store.state.addOnCounter == 3){
              this.$store.commit('showCheckOutPage', 'yes');
              this.$store.commit('setProcessing', 'no');
              this.$scrollTo('.top-bar');
            }
          });


          // Get Opera Misc Items.
          this.$store.dispatch('getOperaMiscItems').then((data) => {
            // #loghere
            let operaMiscItemsList = data.body.MeetingFetchMiscellaneousItemResponse.MiscellaneousItems;
            // Purify list
            let newList = [];
            operaMiscItemsList.forEach(element => {
              let newItem = {
                'id' : element.ItemID,
                'name' : element.Description.Text,
                'amount' : 1,
                'price' : parseFloat(element.RateCodes.Rate.RevenueTypes.BaseRate.Amount),
                'priceWithCC' : parseFloat(element.RateCodes.Rate.RevenueTypes.BaseRate.Amount) == 0 ? 'Free' : element.RateCodes.Rate.RevenueTypes.BaseRate.Amount + ' ' + this.$store.state.venueInfo.currency,
                'service_time' : '--:--'
              };
              newList.push(newItem);
            });

            this.$store.commit('setOperaMiscItems', newList);
            // End Purify list
            this.$store.commit('setAddonAjaxCounter');

            if(this.$store.state.addOnCounter == 3){
              this.$store.commit('showCheckOutPage', 'yes');
              this.$store.commit('setProcessing', 'no');
              this.$scrollTo('.top-bar');
            }
          });

          // Get Opera Menus.
          this.$store.dispatch('getOperaMenus').then((data) => {
            // #loghere
            let operaMenusList = data.body.MeetingFetchMenuResponse.Menus;
            // Purify list
            let newList = [];
            operaMenusList.forEach(element => {
              let price = 0;
              let componentPrice = 0;
              let menuItemsList = [];
              // Package price 
              let revenueTypes = element.Charges.RevenueTypes;
              if(revenueTypes){
                if(revenueTypes.BaseRate){
                  let elementPrice = 0;
                  if(revenueTypes.BaseRate.Amount){
                    elementPrice = parseFloat(revenueTypes.BaseRate.Amount);
                  } else {
                    elementPrice = parseFloat(revenueTypes.BaseRate[0].Amount);
                  }
                  price += parseFloat(elementPrice);
                } else {
                  revenueTypes.forEach(el => {
                    let elementPrice = 0;
                    if(el.BaseRate.Amount){
                      elementPrice = parseFloat(el.BaseRate.Amount);
                    } else {
                      elementPrice = parseFloat(el.BaseRate[0].Amount);
                    }
                    price += parseFloat(elementPrice);
                  });
                }
              }

              menuItemsList.push({
                'id' : element.MenuID,
                'name' : 'Menu',
                'amount' : this.$store.state.delegates,
                'price' : price,
                'priceWithCC' : price + ' ' + this.$store.state.venueInfo.currency,
                'service_time' : '--:--'
              });

              // Component price
              let menuItems = element.MenuItems;
              if(menuItems.MenuItemID){ // only 1 menu item.
                if(menuItems.Charges){
                  let elementPrice = 0;
                  if(menuItems.Charges.RevenueTypes.BaseRate.Amount){
                    elementPrice = parseFloat(menuItems.Charges.RevenueTypes.BaseRate.Amount);
                  } else {
                    elementPrice = parseFloat(menuItems.Charges.RevenueTypes.BaseRate[0].Amount);
                  }
                  componentPrice += elementPrice;
                  menuItemsList.push({
                    'id' : menuItems.MenuItemID,
                    'name' : menuItems['@attributes'].name1,
                    'amount' : this.$store.state.delegates,
                    'price' : elementPrice,
                    'priceWithCC' : elementPrice + ' ' + this.$store.state.venueInfo.currency,
                    'service_time' : '--:--'
                  });
                }
              } else {
                menuItems.forEach(el => {
                  let elementPrice = 0;
                  if(el.Charges.RevenueTypes.BaseRate.Amount){
                    elementPrice = parseFloat(el.Charges.RevenueTypes.BaseRate.Amount);
                  } else {
                    elementPrice = parseFloat(el.Charges.RevenueTypes.BaseRate[0].Amount);
                  }
                  if(el.Charges){
                    componentPrice += elementPrice;
                    menuItemsList.push({
                      'id' : el.MenuItemID,
                      'name' : el['@attributes'].name1,
                      'amount' : this.$store.state.delegates,
                      'price' : elementPrice,
                      'priceWithCC' : elementPrice + ' ' + this.$store.state.venueInfo.currency,
                      'service_time' : '--:--'
                    });
                  }
                });
              }

              let finalPrice = price + componentPrice;

              let newItem = {
                'id' : element.MenuID,
                'name' : element['@attributes'].name,
                'amount' : this.$store.state.delegates,
                'price' : finalPrice,
                'priceWithCC' : finalPrice + ' ' + this.$store.state.venueInfo.currency,
                'service_time' : '--:--',
                'menuItems' : menuItemsList
              };
              if(finalPrice > 0){
                newList.push(newItem);
              }
              
            });

            this.$store.commit('setOperaMenus', newList);

            // End Purify list
            this.$store.commit('setAddonAjaxCounter');

            if(this.$store.state.addOnCounter == 3){
              this.$store.commit('showCheckOutPage', 'yes');
              this.$store.commit('setProcessing', 'no');
              this.$scrollTo('.top-bar');
            }

          });

          return;
        }


        this.$store.commit('setProcessing', 'yes');
        let lang = this.$store.state.selectedLang;
        if(lang == 'en'){
          lang = '';
        } else {
          lang = '/' + lang;
        }
        
        let ajaxUrl = '';
        if(isEnquiry){
          ajaxUrl = baseUrl + '/apiv2/create/order';
        } else {
          ajaxUrl = baseUrl + '/apiv2/create/cart';
        }

        let sentData = {};
        sentData.order_type = currentTab;
        sentData.accepted_gdpr = this._accepted_gdpr;
        sentData.start = startD;
        sentData.end = endD;
        sentData.delegates = this.$store.state.delegates;
        sentData.isInstantBookable = this.isInstantBookable;
        sentData.marketing_platform_ids = dataLayer.getMarketingPlatformIds();
        sentData.mp_ga_session_data = await dataLayer.getGASessionInfo(window.mp_measurement_id);
        sentData.wl_ga_session_data = await dataLayer.getGASessionInfo(window.wl_measurement_id);
        sentData.user_agent = window.navigator.userAgent;
        if(this.$store.state.userInfo == false){
            sentData.company = this.s_company;
            sentData.firstName = this.s_name;
            sentData.lastName = this.s_lname;
            sentData.phone = this.s_phone;
            sentData.email = this.s_email;
            sentData.phone_country = this.$store.state.countryPhoneCode;
            sentData.additional_info = this.s_additional_info;
          } else {

            sentData.company = this.$store.state.userInfo.company;
            sentData.firstName = this.$store.state.userInfo.first_name;
            sentData.lastName = this.$store.state.userInfo.last_name;
            if(this.userPhone == ''){
              sentData.phone = this.s_phone_logged_in;
            } else {
              sentData.phone = this.$store.state.userInfo.phone;
            }
            sentData.email = this.$store.state.userInfo.email;
            sentData.additional_info = this.s_additional_info;
          }

        var bookingType = 'room';
        var bookingRoom = 'room';
        if(currentTab == 'room'){
          bookingRoom = this.$store.state.selectedRoom;
          sentData.room = this.$store.state.selectedRoom;
          sentData.layout = this.$store.state.selectedLayout;
          sentData.package_id = 'none';
          sentData.currency = this.$store.state.venueInfo.currency_code;
          sentData.room_price = this.roomPrice;
          sentData.room_price_total = this.roomTotalPrice;
          sentData.venue_id = this.$store.state.venueInfo.id;
          sentData.language = lang;

          Vue.http.post(ajaxUrl, sentData).then(response => {
            let data = response.body;
            let url = '';
            if(!isEnquiry){
              url = baseUrl + lang + '/checkout/' + data;
            } else {
              if(this.$store.state.userInfo == false){
                url = baseUrl + lang + '/thank-you-anon';
              } else {
                url = baseUrl + lang + '/checkout/' + data;
              }
            }

            // If booking.com here we set some cookies for the thank you page.
            let site_url = window.location.host;
            if(site_url == 'booking.meetingpackage.com' || site_url == 'meetingpackage.com' ){
              let check_in_date = moment(this.$store.state.date, 'DD-MM-YYYY').format('YYYY-MM-DD');
              let check_out_date = moment(check_in_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
              let latlon = this.$store.state.venueInfo.latlon.split(',');
              let latitude = latlon[0];
              let longitude = latlon[1];
              this.$cookie.set('bk_check_in_date', check_in_date);
              this.$cookie.set('bk_check_out_date', check_out_date);
              this.$cookie.set('bk_latitude', latitude);
              this.$cookie.set('bk_longitude', longitude);
            }

            if(isEnquiry){
              Vue.http.post(baseUrl + '/apiv2/process/' + data, sentData).then(response => {
                window.location.href = url;
              });
            } else {
                window.location.href = url;
            }

            }, response => {
          });
        } else {
          // Package booking.
          bookingType = 'package';
          bookingRoom = this.$store.state.selectedRoominPackage;

          sentData.room = this.$store.state.selectedRoominPackage;
          sentData.layout = this.$store.state.selectedLayoutinPackage;
          sentData.package_id = this.$store.state.selectedPackage;
          sentData.venue_id = this.$store.state.venueInfo.id;
          sentData.language = lang;

          Vue.http.post(ajaxUrl, sentData).then(response => {
            let data = response.body;
            let url = '';
            if(!isEnquiry){
              url = baseUrl + lang + '/checkout/' + data;
            } else {
              if(this.$store.state.userInfo == false){
                url = baseUrl + lang + '/thank-you-anon';
              } else {
                url = baseUrl + lang + '/checkout/' + data;
              }
            }
            // If booking.com here we set some cookies for the thank you page.
            let site_url = window.location.host;
            if(site_url == 'booking.meetingpackage.com' || site_url == 'meetingpackage.com'){
              let check_in_date = moment(this.$store.state.date, 'DD-MM-YYYY').format('YYYY-MM-DD');
              let check_out_date = moment(check_in_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
              let latlon = this.$store.state.venueInfo.latlon.split(',');
              let latitude = latlon[0];
              let longitude = latlon[1];
              this.$cookie.set('bk_check_in_date', check_in_date);
              this.$cookie.set('bk_check_out_date', check_out_date);
              this.$cookie.set('bk_latitude', latitude);
              this.$cookie.set('bk_longitude', longitude);
            }

            if(isEnquiry){
              Vue.http.post(baseUrl + '/apiv2/process/' + data, sentData).then(response => {
                window.location.href = url;
              });

            } else {
                window.location.href = url;
            }
            }, response => {
          });
        }
      },
      validateBeforeSubmit() {
        let self= this;
        let countryCode = this.$store.state.countryPhoneCode;
        if(!this.$store.state.userInfo){
          this.$validator.validateAll().then((result) => {
            self.$refs.phoneChild.$validator.validateAll().then((childResult) => {
              if(result && childResult) {
                if(countryCode){
                  this.createBooking();
                } else {
                  this.noCC = true;
                }
              }
            });
          });
        } else {
          if(this.userPhone == ''){
            this.$refs.phoneChild_LoggedIn.$validator.validateAll().then((childResult) => {
              if(childResult) {
                if(countryCode){
                  this.createBooking();
                } else {
                  this.noCC = true;
                }
              }
            });
          } else {
            this.createBooking();
          }
        }
      },
      checkAndChangeStartTime() {
        var selectedDate = moment(this.s_date, 'DD-MM-YYYY')
        var today = moment().startOf('day')
        if (selectedDate.diff(today, 'days') === 0) {
          this.s_time = {HH: (moment().hour() + 1).toString(), mm: "00"}
        }
      }
    },
    watch: {
      venueInfo: function(value){
        let self = this;
        let max_lead = value.lead_times ? value.lead_times.max : '';
        let disabled_days = value.lead_times ? value.lead_times.disabled_days : '';
        let disabled_week_days = value.lead_times ? value.lead_times.disabled_week_days : '';
        let defaultDate = moment(this.$store.state.date, 'DD-MM-YYYY');
        let minDate = moment();
        let maxDate = max_lead ? moment().add(max_lead, 'days').format('DD-MM-YYYY') : '';

        if(parseInt(this.$store.state.venueInfo.id) == 94150){
          minDate = minDate.startOf('hour').add(2, 'hours');
        } else {
          if(!this.isOpera){
            minDate = moment();
          }
        }
        let selectedLang = this.$store.state.selectedLang;
        let options = {
          altInput: true,
          dateFormat: 'd-m-Y',
          altFormat: selectedLang === 'de' ? 'j. F Y' : "F j, Y",
          defaultDate: defaultDate.format('DD-MM-YYYY'),
          minDate: minDate.format('DD-MM-YYYY'),
        };

        if(maxDate){
          options.maxDate = maxDate;
        }
        if(disabled_days || disabled_week_days){
          options.disable = [
            function(date) {
              var dd = date.getDate();
              var mm = date.getMonth()+1; 
              var yyyy = date.getFullYear();
              if( dd < 10 ) {
                dd = '0' + dd;
              } 

              if( mm < 10 ) {
                mm = '0' + mm;
              }

              let dateFormat = dd + '-' + mm + '-' + yyyy;
              if(disabled_days.indexOf(dateFormat) > -1){
                return true;
              }

              let currentWeekDay = date.getDay();
              return disabled_week_days.indexOf(currentWeekDay) > -1;
            }
          ];
        }
        fpickr("#fpick", options);
      },
        countryCode: function (value) {
          if(value == '') {
            this.noCC = true;
          } else {
            this.noCC = false;
          }
        },
        lang: function(value) {
          this.reRender(value)
        },
        '$store.state.isOpera': function(newValue, oldValue) {
            //this.reRender(this.$store.state.selectedLang);
            if(newValue == true && this.$store.state.currentTab == 'package'){
                this.changeCurrentTab('package');
            }
        },
        totalPrice : function(value) {
        },
        detailsText() {
          if (this.$store.state.detailsText == true) {
            this.detailsRoomText = this.$store.state.strings.details;
            this.details = false;
          } else {
            this.detailsRoomText = this.$store.state.strings.hidedetails;
            this.details = true;
          }
        },
        detailsTextPackage() {
          if (this.$store.state.detailsTextPackage == true) {
            this.detailsPackageText = this.$store.state.strings.details;
            this.detailsPackage = false;
          } else {
            this.detailsPackageText = this.$store.state.strings.hidedetails;
            this.detailsPackage = true;
          }
        },
        s_date() {
          this.checkAndChangeStartTime()
        }
    },
    mounted() {
      var defaultLang = window.defaultLang;
      switch (defaultLang) {
        case 'ru':
          fpickr.localize(Russian);
          break;
        case 'fi':
          fpickr.localize(Finnish);
          break;
        case 'da':
          fpickr.localize(Danish);
          break;
        case 'fr':
          fpickr.localize(French);
          break;
        case 'de':
          fpickr.localize(German);
          break;
        case 'it':
          fpickr.localize(Italian);
          break;
        case 'lv':
          fpickr.localize(Latvian);
          break;
        case 'es':
          fpickr.localize(Spanish);
          break;
        case 'sv':
          fpickr.localize(Swedish);
          break;
        case 'zh':
          fpickr.localize(Mandarin);
          break;
        case 'cs':
          fpickr.localize(Czech);
          break;
        case 'en':
          fpickr.localize(english);
          break;
        default:
          fpickr.localize(english);
          break;
      }
      /*fpickr("#fpick", {
          altInput: true,
          dateFormat: "d-m-Y",

          //defaultDate: this.$store.state.datetime,
          //minDate: new Date().fp_incr(2)
      });*/
      fpickr("#fpick_end", {
          altInput: true,
          dateFormat: "d-m-Y",

          //defaultDate: this.$store.state.datetime,
          //minDate: new Date().fp_incr(2)
      });
      fpickr("#fpick_time", {
          dateFormat: "H:i",
          enableTime: true,
          //defaultDate: this.$store.state.datetime,
          //minDate: new Date().fp_incr(2)
      });

      // check what browser
      if (browser) {
        if(browser.name == 'ie' && parseFloat(browser.version) > 10 ) {
          this.isIE = true;
        }
      }
      this.checkAndChangeStartTime()
    },
    computed: {
      isRadisson(){
        return window.isRadisson == '1' ? true : false
      },
      isClosed(){
        return this.$store.state.isClosed;
      },
      venueInfo() {
        return this.$store.state.venueInfo;
      },
      useNewCheckoutPage() {
        return this.$store.state.useNewCheckoutPage;
      },
      isOpera() {
        return this.$store.state.isOpera;
      },
      isNCH() { // Use
        return this.$store.state.useNewCheckoutPage;
      },
      isNCHEnquiry() {
        return this.$store.state.isNCHEnquiry;
      },
      businessHours() {
        return this.$store.state.businessHours;
      },
      isOutsideBusinessHours(){
        return this.$store.state.isOutsideBusinessHours;
      },
      isJury() {
        return this.$store.state.isJury;
      },
      seatingOrderList() {
        if(this.$store.state.useNewCheckoutPage){
          return this.$store.state.seatingOrderList.filter( el => {
                return el.value != "401";
          });
        }
        return this.$store.state.seatingOrderList;
      },
      isMoreThanOneDay(){
        return this.$store.state.isMoreThanOneDay;
      },
      userPhone() {
        return this.$store.state.userPhone;
      },
      countryCode() {
        return this.$store.state.countryPhoneCode;
      },
      isPackageTabRemoved() {
        return this.$store.state.isPackageTabRemoved;
      },
      isLoading() {
        return this.$store.state.isLoading;
      },
      strings () {
	      return this.$store.state.strings
      },
      isDisabled() {
        if(this.$store.state.currentTab == 'room'){
          return this.$store.state.isRoomFormDisabled;
        } else {
          return this.$store.state.isPackageFormDisabled;
        }
      },
      showMultiDayLengthOption() {
        return !this.$store.state.isOpera && window.location.hostname !== 'stage.bookameeting.se' && window.location.hostname !== 'bookameeting.se';
      },
      userInfo() {
        return this.$store.state.userInfo;
      },
      venueInfo(value) {
        this.vInfo = this.$store.state.venueInfo;
        return this.$store.state.venueInfo;
      },
      packageCurrent() {
        if(this.$store.state.currentTab != 'package'){
          return false;
        } else {
          return true;
        }
      },
      roomCurrent() {
        if(this.$store.state.currentTab == 'package'){
          return false;
        } else {
          return true;
        }
      },
      packageInfo() {
        return this.$store.state.packageInfo;
      },
      roomInfo() {
        return this.$store.state.roomInfo;
      },
      selectedPrice(){
        return this.$store.state.selectedPrice;
      },
      selectedPrice_decimal(){
        return this.$store.state.selectedPrice_decimal;
      },
      p_selectedPrice(){
        return this.$store.state.p_selectedPrice;
      },
      p_selectedPrice_decimal(){
        return this.$store.state.p_selectedPrice_decimal;
      },
      currencySymbol(){
        return this.$store.state.currencySymbol;
      },
      footerCollided () {
        return this.$store.state.footerCollided
      },
      showEnquiry () {
        this.$cookie.delete('instant_booking');
        return this.$store.state.showEnquiryForm;
      },
      accepted_gdpr: {
        get: function () {
          this._accepted_gdpr = this.$store.state.userInfo.is_accepted_gdpr;
          return this.$store.state.userInfo.is_accepted_gdpr;
        },
        set: function (value) {
          this._accepted_gdpr = value;
        }
      },
      s_package: {
        get: function(){
          return this.$store.state.selectedPackage
        },
        set: function(selectedPackage){
          if(document.documentElement.clientWidth > 1023){
            this.$scrollTo('#packageList');
          }
          // Mutate selected package.
          this.$store.commit('setSelectedPackage', selectedPackage);
          this.$store.state.packageInfo.forEach(element => {
                if(element.id == selectedPackage) {
                    this.$store.dispatch('sortRoomListinPackage', element.rooms)
                }
            });
          this.$store.commit('changeSelectedPricePackage', selectedPackage);
        }
      },
      s_room: {
        get: function () {
          if(this.$store.state.currentTab == 'room'){
            return this.$store.state.selectedRoom
          } else {
            return this.$store.state.selectedRoominPackage
          }

        },
        set: function (selectedRoom) {
          if(this.$store.state.currentTab == 'room'){
            if(document.documentElement.clientWidth > 1023){
              let count = 0;
              this.$store.state.roomInfo.forEach(el => {
                if(el.id == selectedRoom){
                  this.$store.commit('setSelectedRoomIndex', count);
                }
                count++;
              })
            }
            //this.$scrollTo('.room_' + selectedRoom);
            this.$store.commit('setSelectedRoom', selectedRoom);
            this.$store.commit('setLayoutsInRoom', selectedRoom);
            this.$store.commit('changeSelectedPrice', selectedRoom);
          } else {
            if(document.documentElement.clientWidth > 1023){
              let count = 0;
              this.$store.state.rooms_in_package.forEach(el => {
                if(el.id == selectedRoom){
                  this.$store.commit('setSelectedRoomIndex', count);
                }
                count++;
              })
            }

            this.$store.commit('setSelectedRoominPackage', selectedRoom);
            this.$store.commit('setLayoutsInRoom', selectedRoom);
          }

        }
      },
      s_layout: {
        get: function () {
          if(this.$store.state.currentTab == 'room'){
            return this.$store.state.selectedLayout
          } else {
            return this.$store.state.selectedLayoutinPackage
          }
        },
        set: function (selectedLayout) {
          if(this.$store.state.currentTab == 'room'){
            this.$store.commit('setSelectedLayout', selectedLayout);
            if(!this.isMoreThanOneDay){
              this.$store.dispatch('sortRoomList');
            } else {
              this.$store.dispatch('getRoomOpera', {
                'id' : this.$store.state.venueInfo.id,
                'hotelID' : this.$store.state.venueInfo.operaHotelID,
                'hotelChainCode' : this.$store.state.venueInfo.operaChainCode,
                'hotelServer' : this.$store.state.venueInfo.operaServer
              });
            }
          } else {
            this.$store.commit('setSelectedLayoutinPackage', selectedLayout);
            if(!this.isMoreThanOneDay){
              let roomList = this.$store.state.rooms_in_package;
              this.$store.dispatch('sortRoomListinPackage', roomList);
            } else {
              this.$store.dispatch('getOperaPackage', this.$store.state.venueInfo.id);
            }
          }
        }
      },
      s_meetingLength: {
        get: function () {
          return this.$store.state.meeting_length
        },
        set: function (meetingLength) {
          let isOpera = this.$store.state.isOpera;
          this.$store.commit('setMeetingLength', meetingLength);
          this.$cookie.set('_pref_mt', meetingLength);
          if(meetingLength == 'overone'){
            this.$store.commit('setMoreThanOneDay', true);
            let startDate = this.$store.state.date;
            let endDate = moment(startDate, 'DD-MM-YYYY').add(1, 'days');
            this.$store.commit('setEndDate', endDate.format('DD-MM-YYYY'));
            fpickr("#fpick_end", {
              altInput: true,
              dateFormat: 'd-m-Y',
              defaultDate: endDate.format('DD-MM-YYYY'),
              minDate: endDate.format('DD-MM-YYYY'),
            });
            if(this.$store.state.currentTab == 'room'){
              if(isOpera){
                this.$store.dispatch('getRoomOpera', {
                  'id' : this.$store.state.venueInfo.id,
                  'hotelID' : this.$store.state.venueInfo.operaHotelID,
                  'hotelChainCode' : this.$store.state.venueInfo.operaChainCode,
                  'hotelServer' : this.$store.state.venueInfo.operaServer
                });
              } else {
                this.$store.dispatch('getRoom');
              }
            } else {
              if(isOpera){
                this.$store.dispatch('getOperaPackage', this.$store.state.venueInfo.id);
              } else {
                this.$store.dispatch('getPackage');
              }
            }
          } else {
            this.$store.commit('setMoreThanOneDay', false);
            if(this.$store.state.currentTab == 'room'){
              if(this.$store.state.isOpera){
                this.$store.dispatch('getRoomOpera', {
                  'id' : this.$store.state.venueInfo.id,
                  'hotelID' : this.$store.state.venueInfo.operaHotelID,
                  'hotelChainCode' : this.$store.state.venueInfo.operaChainCode,
                  'hotelServer' : this.$store.state.venueInfo.operaServer
                });
              } else {
                this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
              }   
            } else {
              if(isOpera){
                this.$store.dispatch('getOperaPackage', this.$store.state.venueInfo.id);
              } else {
                this.$store.dispatch('getPackage', this.$store.state.venueInfo.id);
              }
            }
          }
          this.$store.dispatch('checkBizHours');
        }
      },
      s_tab: {
        get: function () {
          return this.$store.state.currentTab
        },
        set: function (currentTab) {
          this.changeCurrentTab(currentTab);
        }
      },
      s_delegates: {

        get: function () {
          return this.$store.state.delegates || 1;
        },
        set: function (delegates) {
          if(delegates == '' || delegates == 0 || delegates == '0'){
            delegates = 1;
          }
          // #hack for berghansen
          if(delegates > 25 && window.location.hostname == 'berghansen.meetingpackage.com'){
            delegates = 25;
          }
          this.$store.commit('setDelegates', delegates);
          this.$cookie.set('_pref_qty', delegates);
          if(this.$store.state.currentTab == 'room'){
            if(this.$store.state.isOpera){
              this.$store.dispatch('getRoomOpera', {
                'id' : this.$store.state.venueInfo.id,
                'hotelID' : this.$store.state.venueInfo.operaHotelID,
                'hotelChainCode' : this.$store.state.venueInfo.operaChainCode,
                'hotelServer' : this.$store.state.venueInfo.operaServer
              });
            } else if(this.$store.state.venueInfo.id == 213275){
               this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
               this.$store.dispatch('sortRoomList');
            }else {
              //this.$store.dispatch('sortRoomList');
              this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
            }          
          } else {
            if(this.$store.state.isOpera){
              this.$store.dispatch('getOperaPackage', this.$store.state.venueInfo.id);
            } else if(this.$store.state.venueInfo.id == 213275){
               this.$store.dispatch('getPackage', this.$store.state.venueInfo.id);
               this.$store.dispatch('sortPackageList');
            } else {
              //this.$store.dispatch('sortPackageList');
              this.$store.dispatch('checkAvailabilityandPricesfromPackage', this.$store.state.datetime);
            }
            
          }
        }
      },
      s_date: {
        get: function () {
          return this.$store.state.date
        },
        set: function (date) {
          this.$store.commit('setDate', date);
          let currentDateTime = moment(this.$store.state.datetime, 'DD-MM-YYYY HH:mm');
          let datetimeCookie = currentDateTime.format('D MMMM, YYYY @ HH:mm');
          let selectedLang = this.$store.state.selectedLang;
          let datetime_cookie_name = selectedLang + '_pref_dt'; 
          this.$cookie.set(datetime_cookie_name, datetimeCookie);
          let _startDate = moment(this.$store.state.date, 'DD-MM-YYYY');
          let _endDate = moment(this.$store.state.end_date, 'DD-MM-YYYY');
          if(_startDate >= _endDate){
            let newEndTime = _startDate.add(1, 'days').format('DD-MM-YYYY');
            this.$store.commit('setEndDate', newEndTime);
            fpickr("#fpick_end", {
              altInput: true,
              dateFormat: 'd-m-Y',
              defaultDate: newEndTime,
              minDate: newEndTime,
            });
          }
          if(this.$store.state.currentTab == 'room'){
            if(this.$store.state.isOpera){
              this.$store.dispatch('getRoomOpera', {
                'id' : this.$store.state.venueInfo.id,
                'hotelID' : this.$store.state.venueInfo.operaHotelID,
                'hotelChainCode' : this.$store.state.venueInfo.operaChainCode,
                'hotelServer' : this.$store.state.venueInfo.operaServer
              });
            }else if(this.$store.state.venueInfo.id == 213275){
               this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
               this.$store.dispatch('sortRoomList');
            }else {
              this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
            }      
          } else {
            if(this.$store.state.isOpera){
              this.$store.dispatch('getOperaPackage', this.$store.state.venueInfo.id);
            } else {
              this.$store.dispatch('checkAvailabilityandPricesfromPackage', this.$store.state.datetime);
            }
          }
          this.$store.dispatch('checkBizHours');
          this.$store.dispatch('checkLeadTimes');
        }
      },
      s_end_date: {
        get: function () {
          return this.$store.state.end_date
        },
        set: function (date) {
          this.$store.commit('setEndDate', date);
          if(this.$store.state.currentTab == 'room'){
            if(this.$store.state.isOpera){
              this.$store.dispatch('getRoomOpera', {
                'id' : this.$store.state.venueInfo.id,
                'hotelID' : this.$store.state.venueInfo.operaHotelID,
                'hotelChainCode' : this.$store.state.venueInfo.operaChainCode,
                'hotelServer' : this.$store.state.venueInfo.operaServer
              });
            }else if(this.$store.state.venueInfo.id == 213275){
               this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
               this.$store.dispatch('sortRoomList');
            } else {
              this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
            }    
          } else {
            if(this.$store.state.isOpera){
              this.$store.dispatch('getOperaPackage', this.$store.state.venueInfo.id);
            }else {
              this.$store.dispatch('checkAvailabilityandPricesfromPackage', this.$store.state.datetime);
            }
          }
        }
      },
      s_time: {
        get: function () {
          let timeArr = this.$store.state.time.split(':');
          //return this.$store.state.time
          return {
            HH: timeArr[0],
            mm: timeArr[1]
          }
        },
        set: function (time) {
          let combinedTime = time.HH + ':' + time.mm;
          this.$store.commit('setTime', combinedTime);
          let currentDateTime = moment(this.$store.state.datetime, 'DD-MM-YYYY HH:mm');
          let datetimeCookie = currentDateTime.format('D MMMM, YYYY @ HH:mm');
          let selectedLang = this.$store.state.selectedLang;
          let datetime_cookie_name = selectedLang + '_pref_dt'; 
          //this.$cookie.set(datetime_cookie_name, datetimeCookie);
          if(this.$store.state.currentTab == 'room'){
            if(this.$store.state.isOpera){
              this.$store.dispatch('getRoomOpera', {
                'id' : this.$store.state.venueInfo.id,
                'hotelID' : this.$store.state.venueInfo.operaHotelID,
                'hotelChainCode' : this.$store.state.venueInfo.operaChainCode,
                'hotelServer' : this.$store.state.venueInfo.operaServer
              });
            } else {
              this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
            }
          } else {
            if(this.$store.state.isOpera){
              this.$store.dispatch('getOperaPackage', this.$store.state.venueInfo.id);
            } else {
              this.$store.dispatch('checkAvailabilityandPricesfromPackage', this.$store.state.datetime);
            }
          }
          this.$store.dispatch('checkBizHours');
        }
      },
      isInstantBookable() {


        if(this.$store.state.currentTab == 'room'){
          if(this.$store.state.isInstantBookable && parseFloat(this.totalPrice) > 0){
            this.$cookie.set('instant_booking', true);
          } else {
            this.$cookie.delete('instant_booking');
          }
          return this.$store.state.isInstantBookable;
        } else {
          if(this.$store.state.isInstantBookablePackage && parseFloat(this.totalPrice) > 0){
            this.$cookie.set('instant_booking', true);
          } else {
            this.$cookie.delete('instant_booking');
          }
          return this.$store.state.isInstantBookablePackage;
        }

      },
      perWhat() {
        return this.$store.state.perWhat;
      },
      totalPrice() {
        let totalPrice = '';
        let currentTab = this.$store.state.currentTab;
        let delegates = this.$store.state.delegates;
        let mt_length = this.$store.state.meeting_length;
        let allPackages = this.$store.state.packageInfo;

        let price = '';
        if(currentTab == 'room'){
          let flag = this.$store.state.totalPriceIndicator;
          price = this.$store.state.price;
          if(flag == 'usual'){
            if(mt_length == 'overnight' || mt_length == 'twodays'){
              totalPrice = 0;
            } else {
              totalPrice = price * parseInt(mt_length);
            }
          } else {
            totalPrice = price;
          }
        } else {
          // If current tab is package.
          price = this.$store.state.p_price
          if(allPackages){
            allPackages.forEach(element => {
            if(element.id == this.$store.state.selectedPackage){
              if(parseInt(element.package_min) > parseInt(delegates)){
                delegates = element.package_min
              }
            }
          });
          }
          totalPrice = price * delegates;
        }
        if(price != ''){
          if(totalPrice == 0){
            this.$store.commit('setShowEnquiryForm', 'yes');
          } else {
            this.$store.commit('setShowEnquiryForm', 'no');
          }
          this.roomPrice = price;
          this.$store.commit('setRoomPrice', price);
          this.roomTotalPrice = totalPrice;
          this.$store.commit('setRoomTotalPrice', totalPrice);
        } else {
          this.$store.commit('setShowEnquiryForm', 'no');
        }
        return parseFloat(totalPrice).toFixed(2);
      },
      currentTab() {
        return this.$store.state.currentTab;
      },
      minimumCharge() {
        let allPackages = this.$store.state.packageInfo;
        let minCharge = '';
        if(allPackages){
          allPackages.forEach(element => {
            if(element.id == this.$store.state.selectedPackage){
              minCharge = element.package_min;
            }
          });
        }
        return minCharge;
      },
      delegates() {
        return parseInt(this.$store.state.delegates);
      },
      detailsText() {
        return this.$store.state.detailsText;
      },
      detailsTextPackage() {
        return this.$store.state.detailsTextPackage;
      },
      phoneNumber(){

        if(window.location.hostname == 'berghansen.meetingpackage.com'){
          return '+47 22 00 80 50';
        }

        let selectedLang = this.$store.state.selectedLang;
        let phoneNumberList = this.$store.state.phoneNumberList;
        if (phoneNumberList[selectedLang]){
          return phoneNumberList[selectedLang];
        } else {
          return phoneNumberList['en'];
        }
      },
      isButtonDisabled(){
        return this.$store.state.finalEvents.length < this.$store.state.eventList.length;
      },
      getTimePickerHourRange() {
        var selectedDate = moment(this.s_date, 'DD-MM-YYYY')
        var today = moment().startOf('day')
        if (selectedDate.diff(today, 'days') === 0)
          return [[moment().hour() + 1, 23]]
        else 
          return [[0, 23]]
      }
    }
  }
</script>
<style scoped>
  .error_block {
    float: left;
  }

  .form__note {
    margin-bottom: 0 !important;
    top: 25px !important;
  }
  
  .button--success {
    margin-top: 18px;
    height: 34px;
    padding: 0;
  }
  .v-spinner {
    margin-left: 0;
  }

  #aside {
      margin-top: 1em;
      height: auto;
  }

  .be-horizontal {
    height: auto;
  }

  #aside form {
      height: 100%;
  }

  .input-width--25 {
    width: 25%;
  }

  .input-width--20 {
    width: 20%;
  }

  .input-width--27 {
    width: 27%;
  }

  .input-width--42 {
    width: 42%;
  }

  .input-width--15 {
    width: 15%;
  }

  .input-width--10 {
    width: 10%;
  }

  .input-width--12 {
    width: 12%;
    margin-right: 0 !important;
  }

  .tabs__item {
    margin: 0 !important;
  }

  .tabs--aside {
    border-left: none !important;
    border-right: none !important;

  }

  .form__label {
    margin-right: 2%;
    float: left;
  }

  .aside__basics {
    border: 1px solid #0055a9 !important;
    background-color: #f3f8fd;
  }

  @media (max-width: 639px){
    .form__label {
        width: 100% !important;
    }
    .be-horizontal {
      height: 475px;
    }
  }

  .col-xl-12 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .be-horizontal .tabs__item {
    flex: none;
    width: 15%;
  }

  .horizontal-form {
    min-height: 124px;
  }
  .tab-title {
    min-height: 34px;
  }
  @media (max-width: 639px){
    .form__input {
        -webkit-appearance: none !important;
        -moz-appearance: none !important;
        appearance: none !important;
    }

    .be-horizontal .tabs__item {
      flex: 1;
      width: auto;
    }
  }


</style>
<style>
 .isNCH .flatpickr-input{
   color: rgb(50,50,50)!important;
 }
 @media screen and (max-width: 640px) {
  .isNCH .flatpickr-input{
    font-size: 16px!important;
    padding-left: 8px!important;
  }
}
</style>